import { render, staticRenderFns } from "./PatientDetailForm.vue?vue&type=template&id=28f54d44&scoped=true"
import script from "./PatientDetailForm.vue?vue&type=script&lang=js"
export * from "./PatientDetailForm.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailForm.vue?vue&type=style&index=0&id=28f54d44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f54d44",
  null
  
)

export default component.exports